import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { PersonaTypings } from '@core/typings/persona.typing';
import { TypeaheadSelectOption } from '@yourcause/common/core-forms';

export interface PersonaQuestionAndAnswersForComponent {
  personaQuestionsAndAnswers: PersonaTypings.PersonaQuestionAndAnswers;
  personaUserAnswers:
    PersonaTypings.PersonaUserAnswers
    | PersonaTypings.PersonaUserNonprofitAnswers
    | PersonaTypings.PersonaUserStagedNonprofitAnswers
    | PersonaTypings.PersonaUserNonprofitAnswersForReview
    | PersonaTypings.PersonaUserStagedNonprofitAnswersForReview;
  formFieldName: string;
  formFieldSelectOptions: TypeaheadSelectOption[];
  userSystemAnswerIdForCustomResponse?: number;
  systemAnswerIdForCustomResponse?: number;
  customResponseForQuestion?: string;
  userSystemAnswerIds?: number[];
}

/**
 * State for Persona Questions and Answers.
 */
@RegisterYCState()
export class PersonaState extends BaseYcState {
  readonly personaQuestionsAndAnswersData: PersonaQuestionAndAnswersForComponent[];
  readonly personaQuestionsAndAnswers: PersonaTypings.GetPersonaQuestionsAndAnswersQueryDto;
  readonly personaUserAnswers: PersonaTypings.GetPersonaUserAnswersQueryDto;
  readonly personaUserNonprofitAnswers: PersonaTypings.GetPersonaUserNonprofitAnswersQueryDto;
  readonly personaUserStagedNonprofitAnswers: PersonaTypings.GetPersonaUserStagedNonprofitAnswersQueryDto;
  readonly personaUserNonprofitAnswersForReview: PersonaTypings.GetPersonaUserNonprofitAnswersForReviewQueryDto;
  readonly personaUserStagedNonprofitAnswersForReview: PersonaTypings.GetPersonaUserStagedNonprofitAnswersForReviewQueryDto;
}
